import React from "react";
import "./style.css";
import { Button, Col, DatePicker, Form, Input, Row } from "antd";

const Index = ({ setActive }) => {
  const [form] = Form.useForm();

  const submitData = async (values) => {
    setActive(true);
    console.log(values);
    let res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/final-walk`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    });
    const { pdfBase64 } = await res.json();
    const byteCharacters = atob(pdfBase64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(null)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    console.log("url", url);
    // Create a link element to download the PDF
    const a = document.createElement("a");
    a.href = url;
    a.download = "Final Walk"; // Set the desired file name
    document.body.appendChild(a);
    a.click();

    // Clean up
    a.remove();
    window.URL.revokeObjectURL(url);
    setActive(false);
  };

  return (
    <div className="main">
      <Form form={form} autoComplete="off" onFinish={submitData}>
        <Row gutter={16} justify={"space-between"}>
          <Col md={8}>
            <label>Date of final walk through</label>
            <Form.Item
              name={"date"}
              rules={[{ required: true, message: "required!" }]}
            >
              <DatePicker />
            </Form.Item>
          </Col>
          <Col md={8}>
            <label>Buyer name</label>
            <Form.Item
              name={"buyer"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Input placeholder="name" />
            </Form.Item>
          </Col>
          <Col md={8}>
            <label>Property address</label>
            <Form.Item
              name={"address"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Input placeholder="address" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Index;
